@file:OptIn(InternalResourceApi::class)

package tregz.tremenz.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/tregz.tremenz.shared.generated.resources/"

@delegate:ResourceContentHash(304_318_109)
public val Res.font.oxanium_bold: FontResource by lazy {
      FontResource("font:oxanium_bold", setOf(
        ResourceItem(setOf(), "${MD}font/oxanium_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(281_511_408)
public val Res.font.oxanium_medium: FontResource by lazy {
      FontResource("font:oxanium_medium", setOf(
        ResourceItem(setOf(), "${MD}font/oxanium_medium.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_677_671_233)
public val Res.font.oxanium_regular: FontResource by lazy {
      FontResource("font:oxanium_regular", setOf(
        ResourceItem(setOf(), "${MD}font/oxanium_regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_971_901_622)
public val Res.font.oxanium_semibold: FontResource by lazy {
      FontResource("font:oxanium_semibold", setOf(
        ResourceItem(setOf(), "${MD}font/oxanium_semibold.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("oxanium_bold", Res.font.oxanium_bold)
  map.put("oxanium_medium", Res.font.oxanium_medium)
  map.put("oxanium_regular", Res.font.oxanium_regular)
  map.put("oxanium_semibold", Res.font.oxanium_semibold)
}
